"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const Clickable_1 = __importDefault(require("../Clickable/Clickable"));
const backwardCompatibilityForProperties_1 = require("../../helpers/backwardCompatibilityForProperties");
const RadioButtonConstants_1 = require("./RadioButtonConstants");
require("./RadioButton.scss");
const RadioButton = (0, react_1.forwardRef)(({ className, 
// Backward compatibility for props naming
componentClassName, text = "", value = "", name = "", disabled = false, defaultChecked = false, children, onSelect, checked, retainChildClick = true, childrenTabIndex = "0", noLabelAnimation = false }, ref) => {
    const inputRef = (0, react_1.useRef)();
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, inputRef] });
    const overrideClassName = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([className, componentClassName]);
    const onChildClick = (0, react_1.useCallback)(() => {
        if (disabled || !retainChildClick)
            return;
        if (inputRef.current) {
            inputRef.current.checked = true;
        }
        if (onSelect) {
            onSelect(null);
        }
    }, [onSelect, inputRef, disabled, retainChildClick]);
    const checkedProps = (0, react_1.useMemo)(() => {
        if (checked !== undefined) {
            return { checked };
        }
        return { defaultChecked };
    }, [checked, defaultChecked]);
    return ((0, jsx_runtime_1.jsxs)("label", Object.assign({ className: (0, classnames_1.default)(RadioButtonConstants_1.baseClassName, overrideClassName, { disabled }) }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ className: `${RadioButtonConstants_1.baseClassName}__radio-input-container` }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ className: `${RadioButtonConstants_1.baseClassName}__radio-input-container__radio-input`, type: "radio", value: value, name: name, disabled: disabled }, checkedProps, { onChange: onSelect, ref: mergedRef })), (0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(`${RadioButtonConstants_1.baseClassName}__radio-input-container__radio-control`, {
                            [`${RadioButtonConstants_1.baseClassName}__radio-input-container__radio-control--label-animation`]: !noLabelAnimation
                        }) })] })), text && (0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${RadioButtonConstants_1.baseClassName}__radio-label` }, { children: text })), children && ((0, jsx_runtime_1.jsx)(Clickable_1.default, Object.assign({ className: "radio-children-wrapper", onClick: onChildClick, tabIndex: childrenTabIndex }, { children: children })))] })));
});
exports.default = RadioButton;
